import BaseTextInputEditor from '../BaseTextInputEditor';

export class CurrencyInputEditor extends BaseTextInputEditor {
  getCellCustomStyle(): string {
    return 'custom-currency-editor';
  }
}
